module.exports = __webpack_public_path__ + "static/media/download.c2a85320.svg";